import { lastValueFrom } from 'rxjs';
import { Action, Store } from '@ngrx/store';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { ParamData } from './param-data.model';
import { GridfilterDataService } from './gridfilter-data';
import { GridFilterRequestPropertiesViewModel } from '@circlon/operate-api-model';

export abstract class CachedListDataResolve implements Resolve<any> {
  cachedState: ParamData;

  abstract action: (params: GridFilterRequestPropertiesViewModel) => Action;

  protected constructor(public gridFilterDataService: GridfilterDataService<any>, public store$: Store<{}>) {
    this.subscribeToStore();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    if (this.cachedState && this.cachedState.params && this.isStillValid(this.cachedState.timeStamp)) {
      return Promise.resolve(this.cachedState.params);
    } else {
      return lastValueFrom(this.gridFilterDataService.getRequestProperties()).then(params => {
        this.store$.dispatch(this.action(params));
        return params;
      });
    }
  }

  isStillValid(timeStamp?: Date): boolean {
    // reload every hour
    return (timeStamp?.getTime() || 0) >= new Date().setHours(new Date().getHours() - 1);
  }
  abstract subscribeToStore();
}
